import { render, staticRenderFns } from "./TutoriaDetalleAgendamiento.vue?vue&type=template&id=5b152d2e&"
import script from "./TutoriaDetalleAgendamiento.vue?vue&type=script&lang=js&"
export * from "./TutoriaDetalleAgendamiento.vue?vue&type=script&lang=js&"
import style0 from "./TutoriaDetalleAgendamiento.vue?vue&type=style&index=0&id=5b152d2e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports